export const open_repairs_display = {
  open_heading: "Open repairs",
  open_count: "{count} open",
  view_open: "View open repairs",
};
